<template>
    <div>
        <v-gobackbutton>返回</v-gobackbutton>
        <FormTitle title="基础信息"/>
        <a-form @submit="handleSubmit" :form="form">
            <a-form-item
                label="域名描述"
                :labelCol="formItemLayout.labelCol"
                :wrapperCol="formItemLayout.wrapperCol"
            >
                <a-input
                    :disabled="disabled"
                    placeholder="请输入域名名称"
                    max-Length="200"
                    style="width:200px"
                    v-decorator="[
                        'domaindesc',
                        {
                            initialValue: record.domaindesc,
                            rules: [{ required: true, message: '请输入域名名称' }]
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="域名地址" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    :disabled="disabled"
                    placeholder="请输入域名地址"
                    max-Length="25"
                    style="width:200px"
                    v-decorator="[
                        'domainurl',
                        {
                            initialValue: record.domainurl,
                            rules: [{ required: true, message: '请输入域名地址' }]
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="鉴权数据获取接口" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    :disabled="disabled"
                    placeholder="请输入鉴权数据获取接口"
                    max-Length="200"
                    style="width:200px"
                    v-decorator="[
                        'authserviceconfig',
                        {
                            initialValue: record.authserviceconfig,
                            rules: [{ required: true, message: '请输入鉴权数据获取接口' }]
                        }
                    ]"
                />
            </a-form-item>
            
            <a-form-item label="鉴权参数获取方式" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    :disabled="disabled"
                    placeholder="鉴权参数获取方式，例：cookie"
                    max-Length="10"
                    style="width:200px"
                    v-decorator="[
                        'authtype',
                        {
                            initialValue: record.authtype,
                            rules: [{ required: true, message: '例：cookie  ' }]
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="鉴权参数标识" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    :disabled="disabled"
                    placeholder="鉴权参数标识,例：mt_id"
                    max-Length="25"
                    style="width:200px"
                    v-decorator="[
                        'authtag',
                        {
                            initialValue: record.authtag,
                            rules: [{ required: true, message: '例：mt_id' }]
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item label="应用环境" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-select :disabled="disabled"
                    placeholder="请选择应用环境"
                    max-Length="25"
                    style="width:200px"
                    v-decorator="[
                        'env',
                        {
                            initialValue: record.env,
                            rules: [{ required: true, message: '请选择应用环境' }]
                        }
                    ]">
                    <a-select-option value="PRO">
                        PRO
                    </a-select-option>
                    <a-select-option value="PRE">
                        PRE
                    </a-select-option>
                    <a-select-option value="SIT">
                        SIT
                    </a-select-option>
                    <a-select-option value="UAT">
                        UAT
                    </a-select-option>
                    <a-select-option value="SIM">
                        SIM
                    </a-select-option>
                </a-select>
            </a-form-item>

           <a-form-item label="返回结构" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    :disabled="disabled"
                    placeholder="请输入返回结构"
                    max-Length="200"
                    style="width:200px"
                    v-decorator="[
                        'loginserviceconfig',
                        {
                            initialValue: record.loginserviceconfig,
                            rules: [{ required: true, message: '请输入返回结结构' }]
                        }
                    ]"
                />
            </a-form-item>
            <a-form-item label="请输入备注" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol">
                <a-input
                    :disabled="disabled"
                    placeholder="请输入备注"
                    max-Length="500"
                    style="width:200px"
                    v-decorator="[
                        'remark',
                        {
                            initialValue: record.remark,
                            rules: [{ required: true, message: '请输入备注' }]
                        }
                    ]"
                />
            </a-form-item>

            <a-form-item :wrapperCol="{ span: 10, offset: 4 }">
                <a-button
                    :disabled="disabled"
                    :key="this.loading.key"
                    :loading="this.loading.effects['domainname/add'] || this.loading.effects['domainname/edit']"
                    type="primary"
                    htmlType="submit"
                >保存</a-button>
                <v-resetbutton :disabled="disabled" class="ml20">重填</v-resetbutton>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import FormTitle from "../../components/FormTitle.vue";
import { mapState } from "vuex";

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 }
};

export default {
    data() {
        return {
            formItemLayout,
            formLayout: "horizontal",
            form: this.$form.createForm(this),

            action: this.$route.params.action,
            disabled: this.$route.params.action == "detail" ? true : false //查看详情的时候禁用编辑框 跟 按钮
        };
    },
    computed: {
        ...mapState("domainname", {
            record: function(state) {
                //这里需要注意 this 指向问题, 如果用箭头函数, 会有this作用域的问题
                return this.action == "add" ? {} : state.record;
            }
        })
    },
    methods: {
        //新域名信息
        add(values) {
            this.$store
                .dispatch({
                    type: "domainname/addDomainname",
                    params: values
                })
                .then(() => {
                    this.$router.push({
                        path: "list"
                    });
                });
        },
        //修改域名信息
        edit(values) {
            values.id = this.record.id;

            this.$store
                .dispatch({
                    type: "domainname/editDomainname",
                    params: values
                })
                .then(() => {
                    this.$router.push({
                        path: "list",
                        query: JSON.parse(this.$route.query.referer)
                    });
                });
        },
        //域名信息表单提交
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;

                //根据路由的action, 动态绑定 新增 或 修改操作
                this[this.action](values);
            });
        }
    },
    mounted() {

        const { query, params } = this.$route;

        if (params.action != "add") {
            this.$store.dispatch({
                type: "domainname/detailDomainname",
                params: query,
                showMsg: false
            });
        }
    },
    components: {
        FormTitle
    }
};
</script>

<style scoped>
</style>